import { action } from 'satcheljs';

export const fetchBalanceAction = action('fetchBalanceAction');
